import { createContext, useContext, useState, ReactNode } from 'react'

interface HelpContextValue {
  helpSection: string | null
  setHelpSection: (section: string | null) => void
}

const HelpContext = createContext<HelpContextValue | null>(null)

export function HelpProvider({ children }: { children: ReactNode }) {
  const [helpSection, setHelpSection] = useState<string | null>(null)
  return (
    <HelpContext.Provider value={{ helpSection, setHelpSection }}>
      {children}
    </HelpContext.Provider>
  )
}

export function useHelp(): HelpContextValue {
  const ctx = useContext(HelpContext)
  if (!ctx) throw new Error('useHelp must be used inside HelpProvider')
  return ctx
}
